"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

require("./BB8NavBar.scss");

require("./BB8Shared.scss");

var BB8NavBar = function BB8NavBar(props) {
  return react_1.default.createElement("div", {
    className: "bb8-nav-bar-wrapper" + " " + props.className
  }, react_1.default.createElement("div", {
    className: "bb8-nav-bar"
  }, react_1.default.createElement("div", {
    className: "bb8-title-wapper"
  }, react_1.default.createElement("div", {
    className: "bb8-title-img-wrapper"
  }, react_1.default.createElement("img", {
    src: require("../assets/images/logo.svg"),
    alt: "company logo"
  })), react_1.default.createElement("h1", {
    id: props.id
  }, props.title)), props.children));
};

exports.default = BB8NavBar;